/**
 * 商品属性选项管理模块
 * 用于在全局存储和导出商品属性选项数据
 */

interface AttrOption {
  productAttrType: string;
  productAttrValue: string;
  key: string;
  value: string;
  label: string;
  [key: string]: any;
}

interface AttrOptionsData {
  brandDataOptions: AttrOption[];
  specificationDataOptions: AttrOption[];
  patternDataOptions: AttrOption[];
  hubDataOptions: AttrOption[];
  loadIndexDataOptions: AttrOption[];
  speedGradeDataOptions: AttrOption[];
  oeProductDataOptions: AttrOption[];
  levelOptions: AttrOption[];
}

class AttrOptionsManager {
  private data: Partial<AttrOptionsData> = {};

  /**
   * 设置所有属性选项
   */
  setAttrOptions(attrOptions: Partial<AttrOptionsData>) {
    this.data = { ...this.data, ...attrOptions };
  }

  /**
   * 获取所有属性选项
   */
  getAllAttrOptions(): Partial<AttrOptionsData> {
    return this.data;
  }

  /**
   * 获取特定属性选项
   */
  getAttrOptions(attrKey: keyof AttrOptionsData): AttrOption[] {
    return this.data[attrKey] || [];
  }

  /**
   * 获取花纹选项
   */
  getPatternOptions(): AttrOption[] {
    return this.data.patternDataOptions || [];
  }

  /**
   * 获取规格选项
   */
  getSpecificationOptions(): AttrOption[] {
    return this.data.specificationDataOptions || [];
  }

  /**
   * 获取品牌选项
   */
  getBrandOptions(): AttrOption[] {
    return this.data.brandDataOptions || [];
  }

  /**
   * 清空所有数据
   */
  clear() {
    this.data = {};
  }

  /**
   * 检查是否已加载
   */
  isLoaded(): boolean {
    return Object.keys(this.data).length > 0;
  }
}

export const attrOptionsManager = new AttrOptionsManager();

export type { AttrOption, AttrOptionsData };
